import _ from 'lodash';

import { TEAM_MEMBER_ROLES } from 'admin/constants/common';

const ACTIONS = {
	publish: 'publish',
	manageOwnStory: 'manage_own_story',
	manageOtherStories: 'manage_other_stories',
	watchAnalytics: 'watch_analytics',
	manageMembers: 'manage_members',
	delete: 'delete',
} as const;

export class RolesFacade {
	user: IUser;

	static actions = ACTIONS;

	constructor(user: IUser) {
		this.user = user;
	}

	static set user(val: IUser) {
		this.user = val;
	}

	private get isActiveTeamPrivate() {
		return this.user.activeTeam === '';
	}

	private get activeTeamRoles() {
		const teamId = this.user.activeTeam;
		const currentTeam = _.find(this.user.teams, { id: teamId });

		return _.get(currentTeam, 'teamMembers.roles', []);
	}

	public get isOrganizationManager() {
		const organizationId = this.user.activeOrganization;
		const currentOrganization = _.find(this.user.organizations, { id: organizationId });

		return _.get(currentOrganization, 'organizationMembers.isManager', false);
	}

	public can = (action: typeof ACTIONS[keyof typeof ACTIONS], teamID: string = '') => {
		const targetTeamRoles = teamID ? this.getTeamRoles(teamID) : this.activeTeamRoles;

		if (this.isActiveTeamPrivate) {
			return true;
		}

		switch (action) {
			case RolesFacade.actions.publish:
				return targetTeamRoles.includes(TEAM_MEMBER_ROLES.PUBLISH);
			case RolesFacade.actions.manageOwnStory:
				return targetTeamRoles.includes(TEAM_MEMBER_ROLES.STORY_MANAGE_OWN);
			case RolesFacade.actions.manageOtherStories:
				return targetTeamRoles.includes(TEAM_MEMBER_ROLES.STORY_MANAGE_OTHERS);
			case RolesFacade.actions.delete:
				return targetTeamRoles.includes(TEAM_MEMBER_ROLES.STORY_DELETE);
			case RolesFacade.actions.watchAnalytics:
				return targetTeamRoles.includes(TEAM_MEMBER_ROLES.ANALYTICS);
			case RolesFacade.actions.manageMembers:
				return targetTeamRoles.includes(TEAM_MEMBER_ROLES.MANAGER_MEMBERS);
			default:
				return false;
		}
	};

	public getTeamRoles = (teamId: string) => {
		const targetTeam = _.find(this.user.teams, { id: teamId });

		return _.get(targetTeam, 'teamMembers.roles', []);
	};
}
